import React from 'react';

import { Box } from '../../../components/Box/Box';
import { Mention } from '../../../components/Mention/Mention';
import { MentionNode } from '../../../types/ContentAst';
import { ElementProps } from '../types/slate';

export const MentionElement = ({
  children,
  element,
}: ElementProps<MentionNode>) => {
  const { text } = element.children[0];

  return (
    <Box as="span" contentEditable={false} styles={componentStyles.mention}>
      <Mention tooltip={element.tooltip} disabled={element.isInvalid}>
        {text}
        {children}
      </Mention>
    </Box>
  );
};

const componentStyles = {
  mention: {
    display: 'inline-block',
  },
};
